import { Box, SxProps, Theme } from '@mui/material';
import React from 'react';

import logo from '../../../assets/img/pruff9.svg';

export interface AppLogoProps {
  sx?: SxProps<Theme>;
}

const AppLogo: React.FC<AppLogoProps> = ({ sx }) => {
  return (
    <Box
      component="img"
      src={logo}
      alt="Pruff"
      sx={{
        height: 25,
        width: 'auto',
        display: 'block',
        padding: 3,
        ...sx,
      }}
    />
  );
};

export default AppLogo;
